/**
 * Prevents Angular change detection from
 * running with certain Web Component callbacks
 * https://ionicframework.com/docs/ja/troubleshooting/runtime#angular-change-detection
 */


(window as any).__Zone_disable_customElements = true;
